import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { DistanceMeasurementComponent, InteriorComponent, PlannerEcsMultiSystem, ProductType } from '@inter-ikea-storageone/range';
import { Direction } from '@inter-ikea-storageone/range/src/core-api/components/DistanceMeasurementComponent';
import LeftSideAttachedToComponent from '@inter-ikea-storagetwo/range/dist/components/LeftSideAttachedToComponent';
import RightSideAttachedToComponent from '@inter-ikea-storagetwo/range/dist/components/RightSideAttachedToComponent';
/**
 * Adds DistanceMeasurementComponent to ELVARLI sections, cabinets and interiors depending on where is scene
 * they are placed
 */
export class ElvarliDistanceMeasurementSystem extends PlannerEcsMultiSystem {
    constructor(coreApi) {
        super(coreApi, 'ElvarliDistanceMeasurementSystem', [
            ComponentIds.MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID,
            ComponentIds.IN_SCENE_COMPONENT_ID,
            LeftSideAttachedToComponent.id,
            RightSideAttachedToComponent.id
        ]);
    }
    onAdd(entity, newComponent) {
        switch (newComponent.typeId) {
            case ComponentIds.IN_SCENE_COMPONENT_ID:
                if (entity.hasComponent(InteriorComponent.id) || this.placedInSection(entity)) {
                    // Interiors inside sections should have distance measurement up and down
                    entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN], [Direction.UP]));
                }
                else if (this.coreApi.entities.isProductType(entity, ProductType.ELVARLI_SECTION)) {
                    // Sections should have distance measurement left and right
                    entity.addComponent(new DistanceMeasurementComponent([Direction.LEFT, Direction.RIGHT], [], true));
                }
                break;
            case LeftSideAttachedToComponent.id:
                // Section connected to section to left. Remove left measurements
                const currentDirections = entity.getComponent(DistanceMeasurementComponent.id)?.directions;
                currentDirections &&
                    entity.addComponent(new DistanceMeasurementComponent(currentDirections.filter(direction => direction !== Direction.LEFT), [], true));
                break;
            case RightSideAttachedToComponent.id:
                // Section connected to section to right. Remove right measurements
                const currentDirections2 = entity.getComponent(DistanceMeasurementComponent.id)?.directions;
                currentDirections2 &&
                    entity.addComponent(new DistanceMeasurementComponent(currentDirections2.filter(direction => direction !== Direction.RIGHT), [], true));
                break;
        }
    }
    onUpdate() { }
    onRemove(entity, oldComponent) {
        switch (oldComponent.typeId) {
            case LeftSideAttachedToComponent.id:
                // Section disconnected from left section. Add measurements to left
                const currentDirections = entity.getComponent(DistanceMeasurementComponent.id)?.directions;
                currentDirections &&
                    entity.addComponent(new DistanceMeasurementComponent([...currentDirections, Direction.LEFT], [], true));
                break;
            case RightSideAttachedToComponent.id:
                // Section disconnected from right section. Add measurements to right
                const currentDirections2 = entity.getComponent(DistanceMeasurementComponent.id)?.directions;
                currentDirections2 &&
                    entity.addComponent(new DistanceMeasurementComponent([...currentDirections2, Direction.RIGHT], [], true));
                break;
        }
    }
    placedInSection(entity) {
        const parent = HierarchyUtils.parent(entity);
        return ((parent && this.coreApi.entities.isProductType(parent, ProductType.ELVARLI_SECTION)) || false);
    }
}
//# sourceMappingURL=ElvarliDistanceMeasurementSystem.js.map